import { useRestMutation } from '@/lib/hook/tanstackQuery'
import { postMessageAdminSchema, PostMessageAdminInput } from '@/lib/restSchemas/discussion'
import { ApiMutationEndpoint } from '@/src/ApiMutationEndpoint'

// Reproduit le resolver postMessageAdmin (apollo/server/resolvers/Discussion/postMessageAdmin.ts) :
// POST contact_request avec { name: subject, message }. Le resolver renvoyait true.
const usePostMessageAdmin = () => {
  const mutation = useRestMutation<unknown, Error, PostMessageAdminInput>({
    ...ApiMutationEndpoint.DISCUSSION.POST_MESSAGE_ADMIN,
    schema: postMessageAdminSchema,
  })

  const postMessage = (subject: string, message: string) =>
    mutation.mutateAsync({ name: subject, message })

  return { ...mutation, postMessage }
}

export default usePostMessageAdmin
